import { api } from "@/services";
import { contentProps } from "@/types";
import qs from "qs";

export async function getContent(page: string | string[]): Promise<contentProps | null> {
  try {
    const { data } = await api.get(`Contents/GetBySlug`, {
      params: {
        slugs: page,
        store: "LINGLONG"
      },
      paramsSerializer: (params) => qs.stringify(params, { arrayFormat: "repeat" })
    });
    const content = data[0];
    return content ?? null;
  } catch (err) {
    console.log(`Error: GetContent ${err?.message}`);
    return null;
  }
}
